import type { AppLocale, ThemePreference } from '@ielts-buddy/shared'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const STORAGE_KEY = 'ielts-buddy:preferences'

interface PreferencesState {
  themePreference: ThemePreference
  locale: AppLocale
  setThemePreference(p: ThemePreference): void
  setLocale(l: AppLocale): void
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      themePreference: 'match_telegram',
      locale: 'en',
      setThemePreference: (themePreference) => set({ themePreference }),
      setLocale: (locale) => set({ locale }),
    }),
    { name: STORAGE_KEY },
  ),
)
